import { render, staticRenderFns } from "./SignUpModal.vue?vue&type=template&id=0d67c3ec&scoped=true&"
import script from "./SignUpModal.vue?vue&type=script&lang=js&"
export * from "./SignUpModal.vue?vue&type=script&lang=js&"
import style0 from "./SignUpModal.vue?vue&type=style&index=0&id=0d67c3ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d67c3ec",
  null
  
)

export default component.exports